var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',_vm._g(_vm._b({ref:"target",staticClass:"d2p-cascade",attrs:{"value":_vm.currentValue,"disabled":_vm.disabled,"readonly":_vm.readonly},on:{"input":_vm.onInput}},'el-cascader',_vm._elProps,false),_vm.extraEvents))}
var staticRenderFns = []

export { render, staticRenderFns }